import clsx from "clsx";

import {
  fullIncreaseIcon,
  noIncreaseIcon,
  partialIncreaseIcon,
} from "../../../../../designSystemIcons";
import { star } from "../../../../../figmaElements";

export const StarRating = ({
  skillMovesLabel,
  weakFootLabel,
  skillMoves,
  weakFoot,
  skillMoveUpgrade,
  weakFootUpgrade,
}: {
  skillMoves: number;
  weakFoot: number;
  skillMovesLabel: string;
  weakFootLabel: string;
  skillMoveUpgrade?: "no-increase" | "partial-increase" | "full-increase";
  weakFootUpgrade?: "no-increase" | "partial-increase" | "full-increase";
}) => {
  return (
    <div className="flex flex-col mx-auto text-center md-sm:gap-x-1 md-lg:gap-x-2 gap-x-3 md-sm:flex-row touch-device:px-2 touch-device:text-xl desktop:text-lg">
      <div className="flex flex-row gap-1 m-auto touch-device:flex-col-reverse md-sm:gap-0 md-lg:gap-1">
        <div className="flex md-lg:gap-x-1 touch-device:m-auto">
          <div className="my-auto text-xs md-lg:text-sm large:text-base">
            {skillMoves}
          </div>
          <div className="w-2 my-auto md-lg:w-3 touch-device:w-3 large:w-4">
            {star}
          </div>
        </div>
        <div className="flex flex-col">
          {(skillMoveUpgrade || weakFootUpgrade) && (
            <div className="w-3 h-3 mx-auto text-ea-dark-green">
              {skillMoveUpgrade === "no-increase"
                ? noIncreaseIcon
                : skillMoveUpgrade === "partial-increase"
                  ? partialIncreaseIcon
                  : skillMoveUpgrade && fullIncreaseIcon}
            </div>
          )}
          <div
            className={clsx(
              "my-auto text-tiny touch-device:text-xs leading-4",
              (skillMoveUpgrade || weakFootUpgrade) && "mb-2 touch-device:mb-0",
              skillMoveUpgrade === "partial-increase" ||
                skillMoveUpgrade === "full-increase"
                ? "text-ea-dark-green"
                : "text-gray-600",
            )}
          >
            {skillMovesLabel}
          </div>
        </div>
      </div>
      <div className="flex gap-1 m-auto flex-row touch-device:flex-col-reverse md-sm:gap-0 md-lg:gap-1">
        <div className="flex md-lg:gap-x-1 touch-device:m-auto">
          <div className="my-auto text-xs md-lg:text-sm large:text-base">
            {weakFoot}
          </div>
          <div className="w-2 my-auto md-lg:w-3 touch-device:w-3 large:w-4">
            {star}
          </div>
        </div>
        <div className="flex flex-col">
          {(weakFootUpgrade || skillMoveUpgrade) && (
            <div className="w-3 h-3 mx-auto text-ea-dark-green">
              {weakFootUpgrade === "no-increase"
                ? noIncreaseIcon
                : weakFootUpgrade === "partial-increase"
                  ? partialIncreaseIcon
                  : weakFootUpgrade && fullIncreaseIcon}
            </div>
          )}
          <div
            className={clsx(
              "text-tiny touch-device:text-xs leading-4",
              (skillMoveUpgrade || weakFootUpgrade) && "mb-2 touch-device:mb-0",
              weakFootUpgrade === "full-increase" ||
                weakFootUpgrade === "partial-increase"
                ? "text-ea-dark-green"
                : "text-gray-600",
            )}
          >
            {weakFootLabel}
          </div>
        </div>
      </div>
    </div>
  );
};
